import { useEffect, useState, useRef } from "react";
import { Affix, Button, Row, Col, Radio, Input, Table, Typography, Space, Modal, Form, Switch, message  } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useParams } from 'react-router-dom';
import "antd/dist/antd.css";
//import Map from './LayersMap/Map'
import BaseMap from "./LayersMap/BaseMap";
import Filters from "../Filters";
import Legend from './LayersMap/Legend/'
import HeaderDetails from "./HeaderDetails";
import Donut from "./Charts/DonutChart/DonutIndex";
import { ChartDivider } from "./Charts/LineChart/ChartsDivider";
import Histogram from "./Charts/HistogramCharts";
import "../../styles/Audience.css";
import { API } from "aws-amplify";
import { iconArrowUp, iconArrowDown } from '../../Helpers/Icons'
import LineChart from "./Charts/LineCharts";
import TableBehavoirs from "./Table/Table";
import pako from "pako";
import ResponsiveVisibility from "../common/ResponsiveVisibility";
import AbortController from 'abort-controller';
import { showMessage } from '../../utils/MessageDataSign'
import ColorsFunction from '../../styles/colors/colors.js';
import { set } from "lodash";

const { Text, Title } = Typography;



const Audience = () => {

  const [filters, setFilters] = useState([])
  const [comportamientos, setComportamientos] = useState([])
  const [ubicaciones, setUbicaciones] = useState([])
  const [genero, setGenero] = useState([])
  const [planCost, setPlanCost] = useState([])
  const [edad, setEdad] = useState([])
  const [marca, setMarca] = useState([])
  const [tipo, setTipo] = useState([])
  const [tipoSuscripcion, setTipoSuscripcion] = useState([])
  const [mercado, setMercado] = useState([])
  const [dataConsumed, setDataConsumed] = useState([])
  const [additionalTelco, setAdditionalTelco] = useState([])
  const [additionalNoTelco, setAdditionalNoTelco] = useState([])
  const [lineAge, setLineAge] = useState([])
  const [userPlan, setUserPlan] = useState([])
  const [servicio, setServicio] = useState([])
  const [aplicacion, setAplicacion] = useState([])
  const [gama, setGama] = useState([])
  const [versionSO, setVersionSO] = useState([])
  const [tecnologia, setTecnologia] = useState([])
  const [tecNavegacion, setTecNavegacion] = useState([])
  const [buttonClicked, setButtonClicked] = useState(false);
  const [sistemaOperativo, setSistemaOperativo] = useState([])
  const [dateNavigation, setDateNavigation] = useState([])
  const [dateNavigationRange, setDateNavigationRange] = useState(["", ""])
  const [rangeNavigationDate, setRangeNavigationDate] = useState()
  const [hourNavigation, setHourNavigation] = useState([])
  const [hourNavigationRange, setHourNavigationRange] = useState(["", ""])
  const [rangeNavigationHour, setRangeNavigationHour] = useState()
  const [dataBaseExternal, setDataBaseExternal] = useState(null)
  const [typeLocation, setTypeLocation] = useState(1)
  const [dbExternalName ,setDBExternalName] = useState(null)
  const [showFilters, setShowFilters] = useState(false);
  const [totalAudience, setTotalAudience] = useState();
  const [totalNewAudience, setTotalNewAudience] = useState();
  const [loadingTotalNewAudience, setLoadingTotalNewAudience] = useState(false)
  const [totalBE, setTotalBE] = useState();
  const [loadingTotalBE, setLoadingTotalBE] = useState(false)
  const [backToTop, setBackToTop] = useState(false);
  const [backToIcon, setBackToIcon] = useState(<DownOutlined />);
  

  const [colors, setColors] = useState(["#009F66", "#F12D12"])
  const [maxCountLocation, setMaxCountLocations] = useState()

  let minColor = useRef("#009F66")
  let maxColor = useRef("#F12D12")

  let params = useParams()
  const [dataAudience, setDataAudience] = useState({ name: 'Nueva Audiencia', filters: [] });


  const [dataMap, setDataMap] = useState({ total: null, newAudience: null, dataExternalBD: null })

  const [dataTotal, setDataTotal] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderTotal, setShowLoaderTotal] = useState(true)

  const [dataDias, setDataDias] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderDias, setShowLoaderDias] = useState(true)

  const [dataHoras, setDataHoras] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderHoras, setShowLoaderHoras] = useState(true)

  const [dataGenero, setDataGenero] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderGenero, setShowLoaderGenero] = useState(true)

  const [dataPlanCost, setDataPlanCost] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderPlanCost, setShowLoaderPlanCost] = useState(true)

  const [dataEdad, setDataEdad] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderEdad, setShowLoaderEdad] = useState(true)

  const [dataMarca, setDataMarca] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderMarca, setShowLoaderMarca] = useState(true)

  const [dataTipo, setDataTipo] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderTipo, setShowLoaderTipo] = useState(true)

  const [dataTipoSuscripcion, setDataTipoSuscripcion] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderTipoSuscripcion, setShowLoaderTipoSuscripcion] = useState(true)

  const [dataMercado, setDataMercado] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderMercado, setShowLoaderMercado] = useState(true)

  const [dataDataConsumed, setDataDataConsumed] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderDataConsumed, setShowLoaderDataConsumed] = useState(true)

  const [dataAdditionalTelco, setDataAdditionalTelco] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderAdditionalTelco, setShowLoaderAdditionalTelco] = useState(true)

  const [dataAdditionalNoTelco, setDataAdditionalNoTelco] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderAdditionalNoTelco, setShowLoaderAdditionalNoTelco] = useState(true)

  const [dataLineAge, setDataLineAge] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderLineAge, setShowLoaderLineAge] = useState(true)

  const [dataUserPlan, setDataUserPlan] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderUserPlan, setShowLoaderUserPlan] = useState(true)

  const [dataServicio, setDataServicio] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderServicio, setShowLoaderServicio] = useState(true)

  const [dataAplicacion, setDataAplicacion] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderAplicacion, setShowLoaderAplicacion] = useState(true)

  const [dataGama, setDataGama] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderGama, setShowLoaderGama] = useState(true)

  const [dataVersionSO, setDataVersionSO] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderVersionSO, setShowLoaderVersionSO] = useState(true)
  
  const [dataTecnologia, setDataTecnologia] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderTecnologia, setShowLoaderTecnologia] = useState(true)

  const [dataTecNavegacion, setDataTecNavegacion] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderTecNavegacion, setShowLoaderTecNavegacion] = useState(true)

  const [dataSistema, setDataSistema] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderSistema, setShowLoaderSistema] = useState(true)

  const [dataComportamientos, setDataComportamientos] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderComportamientos, setShowLoaderComportamientos] = useState(true)

  const [dataDiasTotales, setdataDiasTotales] = useState({ total: null, newAudience: null, dataExternalBD: null })
  const [showLoaderDiasTotales, setShowLoaderDiasTotales] = useState(true)

  const [topComportamientos, setTopComportamientos] = useState({ value: null, name: null })
  const [topUbicaciones, setTopUbicaciones] = useState({ value: null, name: null })
  const [topGeneros, setTopGeneros] = useState({ value: null, name: null })
  const [topPlanCost, setTopPlanCost] = useState({ value: null, name: null });
  const [topEdad, setTopEdad] = useState({ value: null, name: null });
  const [topMarca, setTopMarca] = useState({ value: null, name: null });
  const [topTipoSuscripcion, setTopTipoSuscripcion] = useState({ value: null, name: null });
  const [topMercado, setTopMercado] = useState({ value: null, name: null });
  const [topDataConsumed, setTopDataConsumed] = useState({ value: null, name: null });
  const [topAdditionalTelco, setTopAdditionalTelco] = useState({ value: null, name: null });
  const [topAdditionalNoTelco, setTopAdditionalNoTelco] = useState({ value: null, name: null });
  const [topLineAge, setTopLineAge] = useState({ value: null, name: null });
  const [topUserPlan, setTopUserPlan] = useState({ value: null, name: null });
  const [topServicio, setTopServicio] = useState({ value: null, name: null });
  const [topAplicacion, setTopAplicacion] = useState({ value: null, name: null });
  const [topGama, setTopGama] = useState({ value: null, name: null });
  const [topVersionSO, setTopVersionSO] = useState({ value: null, name: null });
  const [topTecnologia, setTopTecnologia] = useState({ value: null, name: null });
  const [topTecNavegacion, setTopTecNavegacion] = useState({ value: null, name: null });
  const [topDispositivos, setTopDispositivos] = useState({ value: null, name: null });
  const [topSO, setTopSO] = useState({ value: null, name: null });


  const [modalFiltersOpen, setModalFiltersOpen] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [switchUbicaciones,setSwitchUbicaciones] = useState(false)
  const [switchComportamientos,setSwitchComportamientos] = useState(false)
  const [switchGeneros,setSwitchGeneros] = useState(false)
  const [switchEdades,setSwitchEdades] = useState(false)
  const [switchMarcas,setSwitchMarcas] = useState(false)
  const [switchTipos,setSwitchTipos] = useState(false)
  const [switchTipoSuscripcion,setSwitchTipoSuscripcion] = useState(false)
  const [switchMercado, setSwitchMercado] = useState(false)
  const [switchDataConsumed, setSwitchDataConsumed] = useState(false)
  const [switchAdditionalTelco, setSwitchAdditionalTelco] = useState(false)
  const [switchAdditionalNoTelco, setSwitchAdditionalNoTelco] = useState(false)
  const [switchLineAge, setSwitchLineAge] = useState(false)
  const [switchUserPlan, setSwitchUserPlan] = useState(false)
  const [switchServicio, setSwitchServicio] = useState(false)
  const [switchAplicacion, setSwitchAplicacion] = useState(false)
  const [switchGama, setSwitchGama] = useState(false)
  const [switchVersionSO, setSwitchVersionSO] = useState(false)
  const [switchTecnologia, setSwitchTecnologia] = useState(false)
  const [switchTecNavegacion, setSwitchTecNavegacion] = useState(false)
  const [switchPlanCost,setSwitchPlanCost] = useState(false)
  const [switchSO,setSwitchSO] = useState(false)
  const [switchAllAudience,setSwitchAllAudience] = useState(true)
  const [switchNoUsed,setSwitchNoUsed] = useState(true)
  const [filtersActived,setFiltersActived] = useState(true)
  const [filtersApplied,setFiltersApplied] = useState(false)
  const [isQueryRunning, setIsQueryRunning] = useState(false);
  const [isMounted, setIsMounted] = useState(true);
  const abortControllerRef = useRef(<AbortController />);


  const views = [
    { name: 'getCountHistory', setter: setdataDiasTotales, state: dataDiasTotales, onHandleLoader: setShowLoaderDiasTotales, switchHandler: switchNoUsed },
    { name: 'getLocation', setter: setDataMap, state: dataMap, onHandleLoader: () => true, switchHandler: switchUbicaciones },
    { name: 'getAllAudiences', setter: setDataTotal, state: dataTotal, onHandleLoader: setShowLoaderTotal, switchHandler: switchAllAudience },
    { name: 'getDates', setter: setDataDias, state: dataDias, onHandleLoader: setShowLoaderDias, switchHandler: switchNoUsed },
    { name: 'getHours', setter: setDataHoras, state: dataHoras, onHandleLoader: setShowLoaderHoras, switchHandler: switchNoUsed  },
    { name: 'getGender', setter: setDataGenero, state: dataGenero, onHandleLoader: setShowLoaderGenero, switchHandler: switchGeneros },
    { name: 'getPlanCost', setter: setDataPlanCost, state: dataPlanCost, onHandleLoader: setShowLoaderPlanCost, switchHandler: switchPlanCost },
    { name: 'getAges', setter: setDataEdad, state: dataEdad, onHandleLoader: setShowLoaderEdad, switchHandler: switchEdades },
    { name: 'getConsumption', setter: setDataDataConsumed, state: dataDataConsumed, onHandleLoader: setShowLoaderDataConsumed, switchHandler: switchDataConsumed },
    { name: 'getAdditionalTelco', setter: setDataAdditionalTelco, state: dataAdditionalTelco, onHandleLoader: setShowLoaderAdditionalTelco, switchHandler: switchAdditionalTelco },
    { name: 'getAdditionalNonTelco', setter: setDataAdditionalNoTelco, state: dataAdditionalNoTelco, onHandleLoader: setShowLoaderAdditionalNoTelco, switchHandler: switchAdditionalNoTelco },
    { name: 'getBranchDevices', setter: setDataMarca, state: dataMarca, onHandleLoader: setShowLoaderMarca, switchHandler: switchMarcas },
    { name: 'getTypeDevices', setter: setDataTipo, state: dataTipo, onHandleLoader: setShowLoaderTipo, switchHandler: switchTipos }, 
    { name: 'getOsDevices', setter: setDataSistema, state: dataSistema, onHandleLoader: setShowLoaderSistema, switchHandler: switchSO },
    { name: 'getRangeDevices', setter: setDataGama, state: dataGama, onHandleLoader: setShowLoaderGama, switchHandler: switchGama },
    { name: 'getOperatingSystemVersion', setter: setDataVersionSO, state: dataVersionSO, onHandleLoader: setShowLoaderVersionSO, switchHandler: switchVersionSO },
    { name: 'getTechnologyTeam', setter: setDataTecnologia, state: dataTecnologia, onHandleLoader: setShowLoaderTecnologia, switchHandler: switchTecnologia },
    { name: 'getTechnoNavigation', setter: setDataTecNavegacion, state: dataTecNavegacion, onHandleLoader: setShowLoaderTecNavegacion, switchHandler: switchTecNavegacion },
    { name: 'getSubscription', setter: setDataTipoSuscripcion, state: dataTipoSuscripcion, onHandleLoader: setShowLoaderTipoSuscripcion, switchHandler: switchTipoSuscripcion },
    { name: 'getMarket', setter: setDataMercado, state: dataMercado, onHandleLoader: setShowLoaderMercado, switchHandler: switchMercado },
    { name: 'getAgeOfTheline', setter: setDataLineAge, state: dataLineAge, onHandleLoader: setShowLoaderLineAge, switchHandler: switchLineAge },
    { name: 'getPlan', setter: setDataUserPlan, state: dataUserPlan, onHandleLoader: setShowLoaderUserPlan, switchHandler: switchUserPlan },
    { name: 'getService', setter: setDataServicio, state: dataServicio, onHandleLoader: setShowLoaderServicio, switchHandler: switchServicio },
    { name: 'getApplication', setter: setDataAplicacion, state: dataAplicacion, onHandleLoader: setShowLoaderAplicacion, switchHandler: switchAplicacion },
    { name: 'getBehavior', setter: setDataComportamientos, state: dataComportamientos, onHandleLoader: setShowLoaderComportamientos, switchHandler: switchComportamientos }
  ]

  const getAudience = async ({ queryName, filters, idClm }) => {
    let elapsedTime = 0;
    const maxTimeout = 60000; // 1 minuto en milisegundos
    while (elapsedTime < maxTimeout) {
      try {
        const result = await API.graphql({
          query: `query MyQuery ($input: getFiltersRedshiftInput){
            getFiltersRedshift(input: $input){
              key
              type_filter
              description_filter
              value_filter
              is_app
              subscribers
              id_statement
            }
          }`,
          variables:
          {
            input:{query: queryName, filters: filters, idClm: idClm}
          }
        });
        const data = result.data.getFiltersRedshift;
        if (data !== null) {
          return data;
        } else {
          await delay(5000);
          elapsedTime += 5000;
        }
      } catch (err) {
        return null;
      }
    }
    return null;
  };

  const delay = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  };

  const getValues = async ({idStatement, query, setter, state, value}) => {
    let response = [];
    while (response.length === 0) {
      const result = await API.graphql({
        query: `query MyQuery {
          getData(input: {id_statement: "${idStatement}", query: "${query}"}){
            key
            description_filter
            value_filter
            is_app
            subscribers
          }
        }`
      });
      response = result.data.getData;
      if (response.length === 0) {
        await new Promise(resolve => setTimeout(resolve, 5000)); 
      }
    }
    return response;
  };

  const queries = async (typeData, filters = null, idClm = null) => {
    setIsQueryRunning(true); 
    const key = 'loadingKey';
    const currentPath = window.location.pathname;
    const abortController = new AbortController();

    const { signal } = abortController;
    abortControllerRef.current = abortController;

    showMessage('loading', 'Cargando indicadores.', 0, key);

    for (let i = 0; i < views.length; i++) {
      const { name, setter, state, onHandleLoader, switchHandler } = views[i];

      if (window.location.pathname !== currentPath || signal.aborted) {
        abortController.abort();
        break;
      }
      onHandleLoader(true);
      let values_response;

      if ((name === "getDates" && filters && !filters.some(filter => filter.type_filter === 9)) || (name === "getHours" && filters && !filters.some(filter => filter.type_filter === 10) || (name === "getCountHistory" && filters ))){
        setShowLoaderDiasTotales(false)
        continue;
      }
      if (filters === null) {
        values_response = await getAudience({ queryName: name, filters: filters, idClm: idClm, signal: signal });
      } 
      else if (!switchHandler && !filtersActived) {
        continue
      }
      else {
        let new_filters = [];
        filters.forEach(obj => {
            new_filters.push(obj);
        });
        const response = await getAudience({ queryName: name, filters: new_filters, idClm: idClm, signal: signal }); 
        values_response = await getValues({ idStatement: response[0].id_statement, query: name, signal: signal });
      }
      if (idClm == null){
        switch (typeData) {
          case 1:
            // Total Audience
            setter({ ...state, total: values_response });
            break;
          case 2:
            // New Audience
            if (name !== "getCountHistory") setter({ ...state, newAudience: values_response, dataExternalBD: null });
            break;
          case 3:
            // CLM
            if (name !== "getCountHistory") setter({ ...state, newAudience: values_response, dataExternalBD: null });
            break;
          default:
            break;
        }
      }else{
        switch (typeData) {
            case 1:
              setter({ ...state, total: values_response });
              break;
            case 2:
              if (name !== "getCountHistory") setter({ ...state, dataExternalBD: values_response, newAudience: null });
              break;
            case 3:
              if (name !== "getCountHistory") setter({ ...state, dataExternalBD: values_response, newAudience: null });
              break;
            default:
              break;
        }
      }
      onHandleLoader(false);
    }
    if (window.location.pathname !== '/audiences') {
      showMessage('success', 'La carga de indicadores se realizó satisfactoriamente.', 3, key);
    }

    setIsQueryRunning(false);
  };

  useEffect(() => {

    if (params.id) {
      getData(params);
    }
    window.onscroll = toBottomTop;
    queries(1)

    return () => {
      setIsMounted(false);
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      message.destroy();
    };
  }, [])

  useEffect(() => {
    if (dataComportamientos.total && params.id && filters.length !== 0) {
      if (!(dataComportamientos.dataExternalBD || dataComportamientos.newAudience)) {
          setModalFiltersOpen(true)
      }
    }
  }, [dataComportamientos]);

  useEffect(() => {
    if (filters.length !== 0 && dataComportamientos.total){
      setIsQueryRunning(true);
      queries(2, filters, dataBaseExternal)
      setFiltersApplied(true)}
    else if (filtersApplied){
      queries(1)
      setIsQueryRunning(false);
    }
  }, [filters])

const getData = async (params) => {
    const allTodos = await API.graphql({
        query: `
        query GetAudience($id: ID!) {
          getAudience(id: $id) {
            id
            audienceUserId
            name
            versions {
              items {
                version {
                  active
                  filters {
                    key
                    description_filter
                    type_filter
                    value_filter
                  }
                }
              }
            }
            audienceClmId
            clm {
              name
            }
          }
        }`,
        variables: { id: params.id },
    });

    const audience = allTodos.data.getAudience;

    if (audience) {
        const activeVersionItem = audience.versions?.items.find(
            (v) => v.version?.active === true
        );
        let finalFilters = activeVersionItem ? activeVersionItem.version.filters : [];
        const compressedFilter = finalFilters.find(
            (filter) => filter.type_filter === -1
        );

        if (compressedFilter) {
            try {
                const base64DecodedData = atob(compressedFilter.value_filter);
                const compressedData = Uint8Array.from(
                    [...base64DecodedData].map((char) => char.charCodeAt(0))
                );
                const decompressedData = pako.inflate(compressedData, {
                    to: "string",
                });
                let convertToJson = decompressedData
                    .replace(/'/g, '"')
                    .replace(/(\b\d+\b)(?=:)/g, '"$1"');

                const parsedObject = JSON.parse(convertToJson);
                const transformedData = Object.values(parsedObject).map(
                    ({ value_filter, type_filter, key, description_filter }) => ({
                        value_filter,
                        type_filter,
                        key,
                        description_filter,
                    })
                );
                finalFilters = transformedData;

            } catch (error) {
                console.error("Error al descomprimir los filtros:", error);
                finalFilters = [];
            }
        }
        const updatedAudience = { ...audience, filters: finalFilters };
        setDataAudience(updatedAudience);
    }

    if (allTodos.data.getAudience.audienceClmId) {
        setDataBaseExternal(allTodos.data.getAudience.audienceClmId);
        setDBExternalName(allTodos.data.getAudience.clm.name);
    }
};

  useEffect(() => {
    if (dataAudience.filters) {
      dataAudience.filters.forEach(item => {
        switch (item.type_filter) {
          case 1:
            setGenero((prevArray) => [...prevArray, item])
            break;
          case 2:
            setEdad((prevArray) => [...prevArray, item])
            break;
          case 4:
            setUbicaciones((prevArray) => [...prevArray, item])
            break;
          case 5:
            setComportamientos((prevArray) => [...prevArray, item])
            break;
          case 6:
            setMarca((prevArray) => [...prevArray, item])
            break;
          case 7:
            setSistemaOperativo((prevArray) => [...prevArray, item])
            break;
          case 8:
            setTipo((prevArray) => [...prevArray, item])
            break;
          case 9:
            setRangeNavigationDate(item)
            setDateNavigationRange([...item.value_filter.split(',')])
            break;
          case 10:
            setRangeNavigationHour(item)
            setHourNavigationRange([...item.value_filter.split(',')])
            break;
          case 11: 
            setDBExternalName(item.value_filter); 
            break;
          case 14:
            setTipoSuscripcion((prevArray) => [...prevArray, item])
            break;
          case 15:
            setMercado((prevArray) => [...prevArray, item])
            break;
          case 16:
            setGama((prevArray) => [...prevArray, item])
            break;
          case 17:
            setServicio((prevArray) => [...prevArray, item])
            break;
          case 19:
            setAplicacion((prevArray) => [...prevArray, item])
            break;
          case 23:
            setVersionSO((prevArray) => [...prevArray, item])
            break;
          case 24:
            setTecnologia((prevArray) => [...prevArray, item])
            break;
          case 25:
            setTecNavegacion((prevArray) => [...prevArray, item])
            break;        
          case 26:
            setDataConsumed((prevArray) => [...prevArray, item])
            break;      
          case 27:
            setLineAge((prevArray) => [...prevArray, item])
            break;      
          case 28:
            setUserPlan((prevArray) => [...prevArray, item])
            break;
          case 30:
            setAdditionalNoTelco((prevArray) => [...prevArray, item])
            break;
          case 31:
            setAdditionalTelco((prevArray) => [...prevArray, item])
            break;
          case 32:
            setPlanCost((prevArray) => [...prevArray, item])
            break;      
          default:
            break;
        }
      })
    }
  }, [dataAudience]);

  useEffect(() => {
    const auxFilters = [];
    comportamientos.forEach(item => auxFilters.push(item));
    ubicaciones.forEach(item => {
      let filter = { ...item };
      delete filter.subscribers;
      auxFilters.push(filter);
    });
    genero.forEach(item => auxFilters.push(item));
    planCost.forEach(item => auxFilters.push(item));
    edad.forEach(item => auxFilters.push(item));
    dataConsumed.forEach(item => auxFilters.push(item));
    additionalTelco.forEach(item => auxFilters.push(item));
    additionalNoTelco.forEach(item => auxFilters.push(item));
    marca.forEach(item => auxFilters.push(item));
    gama.forEach(item => auxFilters.push(item));
    versionSO.forEach(item => auxFilters.push(item));
    tecnologia.forEach(item => auxFilters.push(item));
    tecNavegacion.forEach(item => auxFilters.push(item));
    tipo.forEach(item => auxFilters.push(item));
    sistemaOperativo.forEach(item => auxFilters.push(item));
    tipoSuscripcion.forEach(item => auxFilters.push(item));
    mercado.forEach(item => auxFilters.push(item));
    lineAge.forEach(item => auxFilters.push(item));
    userPlan.forEach(item => auxFilters.push(item));
    servicio.forEach(item => auxFilters.push(item));
    aplicacion.forEach(item => auxFilters.push(item));
    dateNavigation.forEach(item => auxFilters.push(item));
    hourNavigation.forEach(item => auxFilters.push(item));
    if (rangeNavigationDate) {
      auxFilters.push(rangeNavigationDate);
    }
    if (rangeNavigationHour) {
      auxFilters.push(rangeNavigationHour);
    }
    setFilters(auxFilters);
  }, [buttonClicked]);

  useEffect(() => {
    if (dateNavigationRange[0] !== "") {
      const auxDateString = `${dateNavigationRange[0]},${dateNavigationRange[1]}`
      const filterDate = {
        "key": "1",
        "type_filter": 9,
        "description_filter": "fecha",
        "value_filter": auxDateString
      };
      setRangeNavigationDate(filterDate)
    }
  }, [dateNavigationRange])

  useEffect(() => {
    if (hourNavigationRange[0] !== "") {
      const auxHourString = `${hourNavigationRange[0]},${hourNavigationRange[1]}`
      const filterHour = {
        "key": "1",
        "type_filter": 10,
        "description_filter": "hora",
        "value_filter": auxHourString
      };
      setRangeNavigationHour(filterHour)
    }
  }, [hourNavigationRange])

  useEffect(() => {
    setBackToIcon(backToTop ? <UpOutlined /> : <DownOutlined />);
  }, [backToTop]);

  const toBottomTop = () => {
    if (document.documentElement.scrollTop >= 270) {
      setBackToTop(true);
    } else {
      setBackToTop(false);
    }
  };

  const handleSelectAll = (checked) => {
    setSelectAll(checked);
    setSwitchUbicaciones(checked);
    setSwitchGeneros(checked);
    setSwitchPlanCost(checked);
    setSwitchEdades(checked);
    setSwitchDataConsumed(checked);
    setSwitchAdditionalTelco(checked);
    setSwitchAdditionalNoTelco(checked);
    setSwitchMarcas(checked);
    setSwitchTipos(checked);
    setSwitchTipoSuscripcion(checked);
    setSwitchMercado(checked);
    setSwitchLineAge(checked);
    setSwitchUserPlan(checked);
    setSwitchServicio(checked);
    setSwitchAplicacion(checked);
    setSwitchGama(checked);
    setSwitchVersionSO(checked);
    setSwitchTecnologia(checked);
    setSwitchTecNavegacion(checked);
    setSwitchSO(checked);
    setSwitchComportamientos(checked);
  };

  return (
    <div>
      <Button
        className="style-top-bottom"
        shape="circle"
        icon={backToIcon}
        onClick={() => {
          if (backToTop) {
            document.documentElement.scrollTop = 0;
          } else {
            document.documentElement.scrollTop = 915;
          }
        }}
      />
      <div
        className="fixed-header"
      >

        <div className={!showFilters ? "FiltersComponent" : "FiltersComponent open"} >
        <Filters
            filters={filters}
            setFilters={setFilters}
            comportamientos={comportamientos}
            setComportamientos={setComportamientos}
            ubicaciones={ubicaciones}
            setUbicaciones={setUbicaciones}
            genero={genero}
            setGenero={setGenero}
            planCost={planCost}
            setPlanCost={setPlanCost}
            edad={edad}
            setEdad={setEdad}
            dataConsumed={dataConsumed}
            setDataConsumed={setDataConsumed}
            additionalNoTelco={additionalNoTelco}
            setAdditionalNoTelco={setAdditionalNoTelco}
            additionalTelco={additionalTelco}
            setAdditionalTelco={setAdditionalTelco}
            marca={marca}
            setMarca={setMarca}
            servicio={servicio}
            setServicio={setServicio}
            aplicacion={aplicacion}
            setAplicacion={setAplicacion}
            tipo={tipo}
            setTipo={setTipo}
            tipoSuscripcion={tipoSuscripcion}
            setTipoSuscripcion={setTipoSuscripcion}
            mercado={mercado}
            setMercado={setMercado}
            lineAge={lineAge}
            setLineAge={setLineAge}
            userPlan={userPlan}
            setUserPlan={setUserPlan}
            gama={gama}
            setGama={setGama}
            versionSO={versionSO}
            setVersionSO={setVersionSO}
            tecnologia={tecnologia}
            setTecnologia={setTecnologia}
            tecNavegacion={tecNavegacion}
            setTecNavegacion={setTecNavegacion}
            sistemaOperativo={sistemaOperativo}
            setSistemaOperativo={setSistemaOperativo}
            dateNavigationRange={dateNavigationRange}
            setDateNavigationRange={setDateNavigationRange}
            hourNavigationRange={hourNavigationRange}
            setHourNavigationRange={setHourNavigationRange}
            dataBaseExternal={dataBaseExternal}
            setDataBaseExternal={setDataBaseExternal}
            setDBExternalName={setDBExternalName}

          />

        </div>
        <Button
          size="large"
          onClick={() => {
            setShowFilters(!showFilters)
            if (showFilters) {
              setModalFiltersOpen(true);
            }
          }}
          className={!showFilters ? "ButtonFiltros SubtituloRegularGA" : "ButtonFiltros SubtituloRegularGA OpenFiltros"}
        >
          {!showFilters ? <>
            <Row>
              <Col style={{ textAlign: "left" }} span={20}>
                Mostrar Filtros
              </Col>
              <Col span={4}>
                {!showFilters ? iconArrowUp : iconArrowDown}
              </Col>
            </Row>
          </>
            :
            <>
              <Row>
                <Col style={{ textAlign: "left" }} span={21}>
                  Aplicar Filtros
                </Col>
                <Col span={2} style={{ marginRight: "5px" }}>
                  {!showFilters ? iconArrowUp : iconArrowDown}
                </Col>
              </Row>
            </>
          }
        </Button>
        <Modal
        clasName="ModalGA"
        title="INDICADORES A VISUALIZAR"
        maskClosable= "false"
        open={modalFiltersOpen}
        onCancel={() => setModalFiltersOpen(false)}
        footer={[
          <Button key="back" onClick={() => {setModalFiltersOpen(false)}}>
            Cancelar
          </Button>,
        <Button key="submit" type="primary" onClick={() => {
              setModalFiltersOpen(false);
              setFiltersActived(false);
              setButtonClicked(prevState => !prevState)        
          }}>
          Aceptar
        </Button>
        ]}
      >
      <Form
          labelCol={{
            span: 8,
            offset: 6
          }}
          wrapperCol={{
            span: 4,
          }}
          layout="horizontal"
          style={{
            maxWidth: 600,
          }}
        >
          <Form.Item
            label="SELECCIONAR TODO"
            style={{ fontFamily: 'Roboto-Bold', fontSize: '20px', marginBottom: 8 }}
            labelAlign="left"
            valuePropName="checked"
          >
            <Switch onChange={handleSelectAll} checked={selectAll} />
          </Form.Item>
          <Form.Item label="Ubicaciones" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchUbicaciones(prevState => !prevState)} checked={switchUbicaciones}/>
          </Form.Item>
          <Form.Item label="Géneros" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchGeneros(prevState => !prevState)} checked={switchGeneros}/>
          </Form.Item>
          <Form.Item label="Costo del plan" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchPlanCost(prevState => !prevState)} checked={switchPlanCost}/>
          </Form.Item>
          <Form.Item label="Edades" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchEdades(prevState => !prevState)} checked={switchEdades}/>
          </Form.Item>
          <Form.Item label="Datos consumidos" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchDataConsumed(prevState => !prevState)} checked={switchDataConsumed}/>
          </Form.Item>
          <Form.Item label="Gastos Telco" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchAdditionalTelco(prevState => !prevState)} checked={switchAdditionalTelco}/>
          </Form.Item>
          <Form.Item label="Gastos No Telco" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchAdditionalNoTelco(prevState => !prevState)} checked={switchAdditionalNoTelco}/>
          </Form.Item>
          <Form.Item label="Marcas" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchMarcas(prevState => !prevState)}checked={switchMarcas}/>
          </Form.Item>
          <Form.Item label="Tipos" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchTipos(prevState => !prevState)} checked={switchTipos}/>
          </Form.Item>
          <Form.Item label="Sistemas Operativos" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchSO(prevState => !prevState)} checked={switchSO}/>
          </Form.Item>
          <Form.Item label="Gama" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchGama(prevState => !prevState)} checked={switchGama}/>
          </Form.Item>
          <Form.Item label="Version SO" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchVersionSO(prevState => !prevState)} checked={switchVersionSO}/>
          </Form.Item>
          <Form.Item label="Tenologia equipo" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchTecnologia(prevState => !prevState)} checked={switchTecnologia}/>
          </Form.Item>
          <Form.Item label="Máx. Tec. de Navegación" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchTecNavegacion(prevState => !prevState)} checked={switchTecNavegacion}/>
          </Form.Item>
          <Form.Item label="Tipo Suscripción" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchTipoSuscripcion(prevState => !prevState)} checked={switchTipoSuscripcion}/>
          </Form.Item>
          <Form.Item label="Mercado" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchMercado(prevState => !prevState)} checked={switchMercado}/>
          </Form.Item>
          <Form.Item label="Antigüedad de linea" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchLineAge(prevState => !prevState)} checked={switchLineAge}/>
          </Form.Item>
          <Form.Item label="Plan de usuario" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchUserPlan(prevState => !prevState)} checked={switchUserPlan}/>
          </Form.Item>
          <Form.Item label="Servicios" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchServicio(prevState => !prevState)} checked={switchServicio}/>
          </Form.Item>
          <Form.Item label="Aplicaciones" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchAplicacion(prevState => !prevState)} checked={switchAplicacion}/>
          </Form.Item>
          <Form.Item label="Comportamientos" className="form-item" labelAlign="left" valuePropName="checked">
            <Switch onChange={() => setSwitchComportamientos(prevState => !prevState)} checked={switchComportamientos}/>
          </Form.Item>
        </Form>
      </Modal>
      </div>

      <div style={{ height: "100vh" }}>
        <div
          style={{ position: "absolute", top: 70, zIndex: 99 }}
        >

      <ResponsiveVisibility maxWidth={447} maxHeight={440}> 
          <Radio.Group value={typeLocation} onChange={({ target }) => setTypeLocation(target.value)}>
            <Radio value={1}>Domicilio</Radio>
            <Radio value={2}>Trabajo</Radio>
          </Radio.Group>
          <div>
            <Input
              className="color-input"
              type="color"
              defaultValue={minColor.current}
              onChange={e => minColor.current = e.target.value}
            />
            <Input
              className="sm-input"
              type="color"
              defaultValue={maxColor.current}
              onChange={e => maxColor.current = e.target.value}
            />
            <Button
              className="change-color-button"
              onClick={() => setColors([minColor.current, maxColor.current])}
            >
              Cambiar colores
            </Button>
          </div>
          <Legend minColor={colors[0]} maxColor={colors[1]} subscribers={maxCountLocation} />
        </ResponsiveVisibility>
        </div>
        <BaseMap
          ubicaciones={ubicaciones}
          setUbicaciones={setUbicaciones}
          filters={filters}
          minColor={colors[0]}
          maxColor={colors[1]}
          typeLocation={typeLocation}
          setMaxCountLocations={setMaxCountLocations}
          data={dataMap}
          onTop={setTopUbicaciones}
        />
      </div>
      <div style={{ marginTop: -80, paddingRight: "10%", paddingLeft: "10%" }}>
        <Affix offsetBottom={0}>
          <HeaderDetails
            data={dataTotal}
            filters={filters}
            setButtonClicked={setButtonClicked}
            setComportamientos={setComportamientos}
            setUbicaciones={setUbicaciones}
            topEdad={topEdad}
            topDataConsumed={topDataConsumed}
            topMarca={topMarca}
            setFiltersActived = {setFiltersActived}
            topDispositivos={topDispositivos}
            topPlanCost={topPlanCost}
            topGeneros={topGeneros}
            topComportamientos={topComportamientos}
            topUbicaciones={topUbicaciones}
            topMercado={topMercado}
            topLineAge={topLineAge}
            topUserPlan={topUserPlan}
            topServicio={topServicio}
            topAplicacion={topAplicacion}
            topGama={topGama}
            topVersionSO={topVersionSO}
            topTecnologia={topTecnologia}
            topTecNavegacion={topTecNavegacion}
            topSO={topSO}
            topTipoSuscripcion={topTipoSuscripcion}
            setRangeNavigationHour={setRangeNavigationHour}
            setRangeNavigationDate={setRangeNavigationDate}
            setDateNavigationRange={setDateNavigationRange}
            setHourNavigationRange={setHourNavigationRange}
            setSwitchUbicaciones={setSwitchUbicaciones}
            setSwitchGeneros={setSwitchGeneros}
            setSwitchEdades={setSwitchEdades}
            setSwitchPlanCost={setSwitchPlanCost}
            setSwitchDataConsumed={setSwitchDataConsumed}
            setSwitchAdditionalTelco={setSwitchAdditionalTelco}
            setSwitchAdditionalNoTelco={setSwitchAdditionalNoTelco}
            setSwitchMarcas={setSwitchMarcas}
            setSwitchTipos={setSwitchTipos}
            setSwitchTipoSuscripcion={setSwitchTipoSuscripcion}
            setSwitchMercado={setSwitchMercado}
            setSwitchLineAge={setSwitchLineAge}
            setSwitchUserPlan={setSwitchUserPlan}
            setSwitchServicio={setSwitchServicio}
            setSwitchAplicacion={setSwitchAplicacion}
            setSwitchSO={setSwitchSO}
            setSwitchGama={setSwitchGama}
            setSwitchVersionSO={setSwitchVersionSO}
            setSwitchTecnologia={setSwitchTecnologia}
            setSwitchTecNavegacion={setSwitchTecNavegacion}
            setModalFiltersOpen={setModalFiltersOpen}
            setSwitchComportamientos={setSwitchComportamientos}
            setGenero={setGenero}
            setPlanCost={setPlanCost}
            setEdad={setEdad}
            setDataConsumed={setDataConsumed}
            setAdditionalTelco={setAdditionalTelco}
            setAdditionalNoTelco={setAdditionalNoTelco}
            setMarca={setMarca}
            setSistemaOperativo={setSistemaOperativo}
            setTipo={setTipo}
            setTipoSuscripcion={setTipoSuscripcion}
            setMercado={setMercado}
            setLineAge={setLineAge}
            setUserPlan={setUserPlan}
            setServicio={setServicio}
            setAplicacion={setAplicacion}
            setGama={setGama}
            setVersionSO={setVersionSO}
            setTecnologia={setTecnologia}
            setTecNavegacion={setTecNavegacion}
            setFilters={setFilters}
            dataAudience={dataAudience}
            dateNavigationRange={dateNavigationRange}
            hourNavigationRange={hourNavigationRange}
            totalAudience={totalAudience}
            setDataMap={setDataMap}
            setDataDias={setDataDias} 
            setDataHoras={setDataHoras} 
            setDataGenero={setDataGenero}
            setDataPlanCost={setDataPlanCost}
            setDataEdad={setDataEdad} 
            setDataDataConsumed={setDataDataConsumed}
            setDataAdditionalTelco={setDataAdditionalTelco}
            setDataAdditionalNoTelco={setDataAdditionalNoTelco}
            setDataMarca={setDataMarca}
            setDataTipo={setDataTipo}
            setDataTipoSuscripcion={setDataTipoSuscripcion}
            setDataMercado={setDataMercado}
            setDataLineAge={setDataLineAge}
            setDataUserPlan={setDataUserPlan}
            setDataServicio={setDataServicio}
            setDataAplicacion={setDataAplicacion}
            setDataGama={setDataGama}
            setDataVersionSO={setDataVersionSO}
            setDataTecnologia={setDataTecnologia}
            setDataTecNavegacion={setDataTecNavegacion}
            setDataSistema={setDataSistema}  
            setDataComportamientos={setDataComportamientos}
            totalNewAudience={totalNewAudience}
            params={params}
            totalBE={totalBE}
            dataBaseExternal={dataBaseExternal}
            loadingTotal={showLoaderTotal}
            isQueryRunning={isQueryRunning}
          />
        </Affix>
      </div>
      <div className="FiltrosAudiencica">
        {comportamientos.length != 0 ?
            <div className="FiltroAudiencia">
              Comportamientos:
              {comportamientos.map((item) => <span>{item.value_filter}</span>)}
            </div>
            : null
        }
        {ubicaciones.length != 0 ?
          <div className="FiltroAudiencia">
            Ubicaciones:
            {ubicaciones.map((item) => (
          <span>
            {item.description_filter === 'estado_home'
              ? 'Domicilio'
              : item.description_filter === 'estado_work'
              ? 'Trabajo'
              : 'Domicilio y trabajo'}: {item.value_filter}
          </span>
        ))}
          </div>
          : null
        }   
        {genero.length != 0 ?
          <div className="FiltroAudiencia">
            Genero:
            {genero.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {planCost.length != 0 ?
          <div className="FiltroAudiencia">
            Costo del Plan:
            {planCost.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {edad.length != 0 ?
          <div className="FiltroAudiencia">
            Edad:
            {edad.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {dataConsumed.length != 0 ?
          <div className="FiltroAudiencia">
            Datos Consumidos:
            {dataConsumed.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {additionalTelco.length != 0 ?
          <div className="FiltroAudiencia">
            Gastos Telco:
            {additionalTelco.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {additionalNoTelco.length != 0 ?
          <div className="FiltroAudiencia">
            Gastos No Telco:
            {additionalNoTelco.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {marca.length != 0 ?
          <div className="FiltroAudiencia">
            Marca:
            {marca.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {tipo.length != 0 ?
          <div className="FiltroAudiencia">
            Tipo:
            {tipo.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {tipoSuscripcion.length != 0 ?
          <div className="FiltroAudiencia">
            TipoSuscripción:
            {tipoSuscripcion.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {mercado.length != 0 ?
          <div className="FiltroAudiencia">
            Mercado:
            {mercado.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {lineAge.length != 0 ?
          <div className="FiltroAudiencia">
            Antigüedad linea:
            {lineAge.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {userPlan.length != 0 ?
          <div className="FiltroAudiencia">
            Plan de usuario:
            {userPlan.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {servicio.length != 0 ?
          <div className="FiltroAudiencia">
            Servicio:
            {servicio.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {aplicacion.length != 0 ?
          <div className="FiltroAudiencia">
            Aplicación:
            {aplicacion.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {gama.length != 0 ?
          <div className="FiltroAudiencia">
            Gama:
            {gama.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {versionSO.length != 0 ?
          <div className="FiltroAudiencia">
            Version_SO:
            {versionSO.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {tecnologia.length != 0 ?
          <div className="FiltroAudiencia">
            Tecnologia_equipo:
            {tecnologia.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {tecNavegacion.length != 0 ?
          <div className="FiltroAudiencia">
            Tecnologia_navegación:
            {tecNavegacion.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {sistemaOperativo.length != 0 ?
          <div className="FiltroAudiencia">
            SO:
            {sistemaOperativo.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {dateNavigation.length != 0 ?
          <div className="FiltroAudiencia">
            Fecha:
            {
              (dateNavigation.length != 0) ?
                ((Array.isArray(dateNavigation[dateNavigation.length - 1])) ?
                  dateNavigation.map((item) => item.map(e => <span>{e.data.value_filter}</span>))
                  : null)
                : null
            }
          </div>
          : null
        }
        {dateNavigationRange && dateNavigationRange[0] != "" ?
          <div className="FiltroAudiencia">
            Rango de Fecha:
            <span>{dateNavigationRange[0]}, {dateNavigationRange[1]}</span>
          </div>
          : null
        }
        {hourNavigation.length != 0 ?
          <div className="FiltroAudiencia">
            Hora:
            {hourNavigation.map((item) => <span>{item.value_filter}</span>)}
          </div>
          : null
        }
        {hourNavigationRange && hourNavigationRange[0] != "" ?
          <div className="FiltroAudiencia">
            Rango de Horas:
            <span>{hourNavigationRange[0]} - {hourNavigationRange[1]}</span>
          </div>
          : null
        }
        {dbExternalName ? (
          <div className="FiltroAudiencia">
              BD Externa:
            <span>{dbExternalName}</span>
          </div>
        ) : null}
      </div>
      <div className="ChartsGA">
        <ChartDivider title="TOTAL DE" stitle="SUSCRIPTORES" />
        <LineChart
          data={dataDiasTotales}
          showLoadingData={showLoaderDiasTotales}
          filters={filters}
          nameChart="TOTAL DE SUSCRIPTORES POR DÍA" 
        />
        <br />
        {dateNavigationRange[0] !== "" ?
          <>
            <br />
            <LineChart
              data={dataDias}
              showLoadingData={showLoaderDias}
              filters={filters}
              nameChart="SUSCRIPTORES ÚLTIMOS DÍAS"
            />
          </>
          : null
        }
        {hourNavigationRange[0] !== "" ?
          <>
            <br />
            <LineChart
              data={dataHoras}
              showLoadingData={showLoaderHoras}
              filters={filters}
              nameChart="SUSCRIPTORES ÚLTIMAS HORAS"
            />
          </>
          : null
        }
        {(filtersActived || switchGeneros || switchEdades || switchPlanCost) && (
        <ChartDivider title="DATOS" stitle="DEMOGRÁFICOS" />
        )}
        {(filtersActived || switchGeneros) && (
        <>
          <Donut
            genero={genero}
            filters={filters}
            data={dataGenero}
            onTop={setTopGeneros}
            showLoadingData={showLoaderGenero}
            nameChart="GÉNERO"
          />
          <br />
        </>)}
        {(filtersActived || switchPlanCost) && (
        <>
        <ResponsiveVisibility maxWidth={901}>
          <Histogram
            data={dataPlanCost}
            filter={planCost}
            nameChart="Costo de Plan"
            showLoadingData={showLoaderPlanCost}
            typeChart="Bar"
            onTop={setTopPlanCost}
          />
        </ResponsiveVisibility>
        <br />       
        </>
        )}  
        {(filtersActived || switchEdades) && (
        <>
        <ResponsiveVisibility maxWidth={901}>
          <Histogram
            data={dataEdad}
            filter={edad}
            nameChart="EDAD"
            showLoadingData={showLoaderEdad}
            typeChart="Column"
            onTop={setTopEdad}
          />
        </ResponsiveVisibility>
          <br />
        </>
        )}
        {(filtersActived || switchDataConsumed || switchAdditionalTelco || switchAdditionalNoTelco) && (
          <ChartDivider title="DATOS DE" stitle="CONSUMOS" />
        )}
        {(filtersActived || switchDataConsumed) && (
          <>
          <ResponsiveVisibility maxWidth={901}>
            <Histogram
              data={dataDataConsumed}
              filter={dataConsumed}
              showLoadingData={showLoaderDataConsumed}
              nameChart="CONSUMO DE DATOS (MB)"
              typeChart="Column"
              onTop={setTopDataConsumed}
            />
          </ResponsiveVisibility>
            <br />
          </>
        )}
        {(filtersActived || switchAdditionalTelco) && (
          <>
          <ResponsiveVisibility maxWidth={901}>
            <Histogram
              data={dataAdditionalTelco}
              filter={additionalTelco}
              showLoadingData={showLoaderAdditionalTelco}
              nameChart="Gastos Adicionales (Telco)"
              typeChart="Column"
              onTop={setTopAdditionalTelco}
            />
          </ResponsiveVisibility>
            <br />
          </>
        )}
        {(filtersActived || switchAdditionalNoTelco) && (
          <>
          <ResponsiveVisibility maxWidth={901}>
            <Histogram
              data={dataAdditionalNoTelco}
              filter={additionalNoTelco}
              showLoadingData={showLoaderAdditionalNoTelco}
              nameChart="Gastos Adicionales (No Telco)"
              typeChart="Column"
              onTop={setTopAdditionalNoTelco}
            />
          </ResponsiveVisibility>
            <br />
          </>
        )}
        {(filtersActived || switchMarcas || switchTipos || switchSO || switchGama || switchVersionSO || switchTecnologia || switchTecNavegacion) && (
          <ChartDivider title="DATOS DEL" stitle="DISPOSITIVO" />
        )}
        {(filtersActived || switchMarcas) && (
        <>
        <ResponsiveVisibility maxWidth={901}>
          <Histogram
            data={dataMarca}
            filter={marca}
            showLoadingData={showLoaderMarca}
            nameChart="MARCA"
            typeChart="Column"
            onTop={setTopMarca}
          />
        </ResponsiveVisibility>
          <br />
        </>
        )}
        {(filtersActived || switchTipos) && (
        <>
        <ResponsiveVisibility maxWidth={901}>
          <Histogram
            data={dataTipo}
            filter={tipo}
            showLoadingData={showLoaderTipo}
            nameChart="TIPO"
            typeChart="Column"
            onTop={setTopDispositivos}
          />
        </ResponsiveVisibility>
          <br />
        </>
        )}
        {(filtersActived || switchSO) && (
        <>
        <ResponsiveVisibility maxWidth={901}>
          <Histogram
            data={dataSistema}
            filter={sistemaOperativo}
            showLoadingData={showLoaderSistema}
            nameChart="SISTEMA OPERATIVO"
            typeChart="Column"
            onTop={setTopSO}
          />
        </ResponsiveVisibility>
          <br />
        </>
        )}
        {(filtersActived || switchGama) && (
        <>
        <ResponsiveVisibility maxWidth={901}>
          <Histogram
            data={dataGama}
            filter={gama}
            showLoadingData={showLoaderGama}
            nameChart="GAMA DISPOSITIVO"
            typeChart="Column"
            onTop={setTopGama}
          />
        </ResponsiveVisibility>
          <br />
        </>
        )}
        {(filtersActived || switchVersionSO) && (
        <>
        <ResponsiveVisibility maxWidth={901}>
          <Histogram
            data={dataVersionSO}
            filter={versionSO}
            showLoadingData={showLoaderVersionSO}
            nameChart="VERSIÓN SISTEMA OPERATIVO"
            typeChart="Column"
            onTop={setTopVersionSO}
          />
        </ResponsiveVisibility>
          <br />
        </>
        )}
        {(filtersActived || switchTecnologia) && (
        <>
        <ResponsiveVisibility maxWidth={901}>
          <Histogram
            data={dataTecnologia}
            filter={tecnologia}
            showLoadingData={showLoaderTecnologia}
            nameChart="TECNOLOGÍA DEL EQUIPO"
            typeChart="Column"
            onTop={setTopTecnologia}
          />
        </ResponsiveVisibility>
          <br />
        </>
        )}
        {(filtersActived || switchTecNavegacion) && (
        <>
          <Histogram
            data={dataTecNavegacion}
            filter={tecNavegacion}
            showLoadingData={showLoaderTecNavegacion}
            nameChart="MÁXIMA TECNOLOGÍA DE NAVEGACIÓN"
            typeChart="Column"
            onTop={setTopTecNavegacion}
          />
          <br />
        </>
        )}
        {(filtersActived || switchTipoSuscripcion || switchMercado || switchLineAge || switchUserPlan) && (
          <ChartDivider title="PERFIL DEL" stitle="USUARIO" />
        )}
        {(filtersActived || switchTipoSuscripcion) && (
        <>
        <ResponsiveVisibility maxWidth={901}>
          <Histogram
            data={dataTipoSuscripcion}
            filter={tipoSuscripcion}
            showLoadingData={showLoaderTipoSuscripcion}
            nameChart="TIPO SUSCRIPCIÓN"
            typeChart="Column"
            onTop={setTopTipoSuscripcion}
          />
        </ResponsiveVisibility>
          <br />
        </>
        )}
        {(filtersActived || switchMercado) && (
        <>
        <ResponsiveVisibility maxWidth={901}>
          <Histogram
            data={dataMercado}
            filter={mercado}
            showLoadingData={showLoaderMercado}
            nameChart="MERCADO"
            typeChart="Column"
            onTop={setTopMercado}
          />
        </ResponsiveVisibility>
          <br />
        </>
        )}
        {(filtersActived || switchLineAge) && (
        <>
        <ResponsiveVisibility maxWidth={901}>
          <Histogram
            data={dataLineAge}
            filter={lineAge}
            showLoadingData={showLoaderLineAge}
            nameChart="ANTIGÜEDAD DE LA LÍNEA"
            typeChart="Column"
            onTop={setTopLineAge}
          />
        </ResponsiveVisibility>
          <br />
        </>
        )}
        {(filtersActived || switchUserPlan) && (
        <>
        <ResponsiveVisibility maxWidth={901}>
          <Histogram
            data={dataUserPlan}
            filter={userPlan}
            showLoadingData={showLoaderUserPlan}
            nameChart="PLAN DE USUARIO"
            typeChart="Column"
            onTop={setTopUserPlan}
          />
        </ResponsiveVisibility>
          <br />
        </>
        )}
        {(filtersActived || switchServicio) && (
          <>
            <ChartDivider title="DATOS DE" stitle="SERVICIOS" />
            <ResponsiveVisibility maxWidth={901}>
              <Histogram
                data={dataServicio}
                filter={servicio}
                showLoadingData={showLoaderServicio}
                nameChart="SERVICIO"
                typeChart="Column"
                onTop={setTopServicio}
              />
            </ResponsiveVisibility>
            <br />
          </>
        )}
        {(filtersActived || switchAplicacion) && (
          <>
            <ChartDivider title="DATOS DE" stitle="APLICACIONES" />
            <ResponsiveVisibility maxWidth={901}>
              <Histogram
                data={dataAplicacion}
                filter={aplicacion}
                showLoadingData={showLoaderAplicacion}
                nameChart="APLICACIÓN"
                typeChart="Column"
                onTop={setTopAplicacion}
              />
            </ResponsiveVisibility>
            <br />
          </>
        )}
        {(filtersActived || switchComportamientos) && (
          <>
            <br />
            <ChartDivider title="COMPORTAMIENTOS" />
            <TableBehavoirs
              data={dataComportamientos}
              filters={filters}
              dataBaseExternal={dataBaseExternal}
              showLoadingData={showLoaderComportamientos}
              onTop={setTopComportamientos}
            />
        </>
        )}
      </div>
    </div>
  );
};

export default Audience;
